import { gql, MutationHookOptions, TypedDocumentNode, useMutation } from "@apollo/client";

import {
  CreateScenarioDraftVersionMutation,
  CreateScenarioDraftVersionMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { scenarioVersionWithRulesFragment } from "src/graphql/anti-fraud/fragments/ScenarioVersionFragment";

export const createScenarioDraftVersionMutation = gql`
  mutation createScenarioDraftVersion($scenarioId: ID!) {
    createDraftVersion(input: { scenarioId: $scenarioId }) {
      ...ScenarioVersionWithRulesFragment
    }
  }

  ${scenarioVersionWithRulesFragment}
` as TypedDocumentNode<
  CreateScenarioDraftVersionMutation,
  CreateScenarioDraftVersionMutationVariables
>;

export const useCreateScenarioDraftVersionMutation = (
  options?: MutationHookOptions<
    CreateScenarioDraftVersionMutation,
    CreateScenarioDraftVersionMutationVariables
  >
) => {
  return useMutation(createScenarioDraftVersionMutation, options);
};
